export class MarketingReferralConstants {
    static isReferrerInformationEmpty(referrerInformation) {
        if (referrerInformation.referrer != undefined) return false;
        if (referrerInformation.referralCode != undefined) return false;
        return true;
    }
}
MarketingReferralConstants.marketingReferralCodeURLVariable = 'referralCode';
MarketingReferralConstants.maxReferralCodeLength = 20;
MarketingReferralConstants.maxReferrerLength = 150;
